import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { LOGO } from "@/lib/api";

export const Footer = ({ contact }) => {
  const { t } = useApp();
  return (
    <footer className="border-t border-white/10 bg-[#070707] px-6 md:px-12 pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-14">
        <div className="md:col-span-5">
          <img src={LOGO} alt="BEDAS" className="h-14 md:h-16 w-auto object-contain logo-light mb-6" />
          <p className="text-sm text-neutral-500 max-w-sm leading-relaxed">
            Exclusive bedding — yatak, baza ve başlıkta el işçiliği ile üretilen zamansız koleksiyonlar.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="overline mb-5">{t("products")}</p>
          <div className="flex flex-col gap-3 text-sm text-neutral-400">
            <Link to="/products" className="hover:text-gold transition-colors duration-300">{t("allProducts")}</Link>
            <Link to="/catalog" className="hover:text-gold transition-colors duration-300">{t("catalog")}</Link>
            <Link to="/fairs" className="hover:text-gold transition-colors duration-300">{t("fairs")}</Link>
            <Link to="/news" className="hover:text-gold transition-colors duration-300">{t("news")}</Link>
          </div>
        </div>
        <div className="md:col-span-4">
          <p className="overline mb-5">{t("contact")}</p>
          <div className="flex flex-col gap-3 text-sm text-neutral-400">
            <span>{contact?.address}</span>
            <a href={`tel:${contact?.phone}`} className="hover:text-gold transition-colors duration-300">{contact?.phone}</a>
            <a href={`mailto:${contact?.email}`} className="hover:text-gold transition-colors duration-300">{contact?.email}</a>
          </div>
        </div>
      </div>
      <div className="max-w-[1600px] mx-auto mt-16 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 text-[0.68rem] uppercase tracking-[0.2em] text-neutral-600">
        <span>© {new Date().getFullYear()} BEDAS Exclusive Bedding</span>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-gold transition-colors duration-300">{t("admin")}</Link>
      </div>
    </footer>
  );
};

export default Footer;
